/**
 * Selectors are constructed by receiving a list of classNames applied to
 * DOM-elements. These classNames will be transformed to QuerySelectors by our
 * makeSelectors() method.
 */

/**
 * A QuerySelector represents a selector that can be used to access a
 * particular DOM-Element, e.g. by using document.querySelector(QuerySelector).
 */

/**
 * Makes an object of selectors that can be used to access DOM-elements related
 * to the passed classNames imperatively without the need to manually transform
 * classNames into selectors.
 *
 * This can be used to both avoid manual work and at the same time it allows
 * components to create an object of selectors based on the already defined
 * classes (using linaria.css``) scoped to the given component.
 */

function makeSelectors(selectors) {
  if (typeof selectors === "string") {
    return Object.assign(() => `.${selectors}`, {
      className: selectors
    });
  }
  return Object.entries(selectors).reduce((acc, [rawSelector, className]) => {
    // @ts-expect-error TypeScript cannot correctly infer that `typeof
    // selector` =T
    acc[rawSelector] = Object.assign(() => `.${className}`, {
      className
    });
    return acc;
  }, {});
}

export { makeSelectors };
//# sourceMappingURL=maker.selectors.js.map
